import { set } from 'lodash';

import { lookupTableReducer } from 'Modules/core/redux';

import { environmentActionTypes as actionTypes } from './actions';


const defaultState = {
    initialized: false,
};

const actionLookup = {
    [actionTypes.SET_ENVIRONMENT]: (state, $payload) => ({
        ...state,
        ...$payload,
    }),
    [actionTypes.SET_BUSY]: (state, $payload, { path }) => ({
        ...set({ ...state }, `${path}.busy`, $payload),
    }),
};

export const reducer = lookupTableReducer(defaultState, actionLookup);
